import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'
import { bullObject } from '../bull/bullObject'

export const semenProgramObject = z.object({
  id: z.string().uuid(),
  name: z.string(),
  usageLimit: z.number().int(),
  description: z.string().nullish(),
  bullId: bullObject.shape.id,
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type SemenProgramType = z.infer<typeof semenProgramObject>

export const propertyMap = {
  id: sql`id`,
  name: sql`name`,
  usageLimit: sql`usage_limit`,
  description: sql`description`,
  bullId: sql`bull_id`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  deletedAt: sql`deleted_at`,
}
